'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { ReactNode } from 'react'
import { popModal } from '@/components/modals'

interface IPricingHeroProps {
  trigger?: string
  workspaceSelector?: ReactNode
  showCreditUsageLink?: boolean
}

/**
 * Hero section for the pricing page including title, description, and features
 */
export function PricingHero({
  trigger,
  workspaceSelector,
  showCreditUsageLink = false,
}: IPricingHeroProps) {
  const t = useTranslations('pricing-v3')

  return (
    <section className="container mx-auto px-4 text-center py-8 pb-3 relative">
      <div className="mb-4 md:mb-8" />

      {/* Title with Workspace Selector */}
      <div className="flex items-center justify-center gap-4 mb-4">
        <h1 className="text-4xl font-bold text-white md:text-5xl">
          {t('hero.workspace_pricing_title')}
        </h1>
        {workspaceSelector && (
          <div className="flex-shrink-0">{workspaceSelector}</div>
        )}
      </div>

      {/* Description */}
      <p className="mb-8 max-w-3xl mx-auto text-base text-white opacity-80 font-light hidden md:block">
        {trigger ? t(`hero.${trigger}.description`) : t('hero.description')}
      </p>

      {/* Credit Usage Link */}
      {showCreditUsageLink && (
        <div className="mb-8 max-w-3xl mx-auto">
          <Link
            href="/subscription"
            onClick={() => popModal()}
            className="text-sm text-white/60 hover:text-white/80 underline underline-offset-2 transition-colors"
          >
            {t('hero.see_credit_usage')}
          </Link>
        </div>
      )}
    </section>
  )
}
